import { useState } from "react";
import { createPortal } from "react-dom";
import { clsx } from "clsx";

import FacebookIcon from "../../icons/socials/facebook.svg";
import GoodReadsIcon from "../../icons/socials/goodreads.svg";
import InstagramIcon from "../../icons/socials/instagram.svg";
import LinkedInIcon from "../../icons/socials/linkedin.svg";
import WebsiteIcon from "../../icons/socials/website.svg";
import YouTubeIcon from "../../icons/socials/youtube.svg";
import XIcon from "../../icons/socials/x.svg";


import CreateGame from "../modals/CreateGame";
import JoinGame from "../modals/JoinGame";

const root = document.getElementById("root");

function Home() {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showJoinModal, setJoinModal] = useState(false);

	const style = {
		header: {
			section: "w-full text-center py-2 bg-white",
			heading: "text-3xl font-serif",
			subtext: "text-lg my-2",
			link: "text-blue-400 underline italic"
		},
		footer: {
			section: "w-full py-2 fixed bottom-0 bg-white",
			item: "w-6 h-6",
			links: "text-blue-400 italic"
		},
		info: "flex flex-col",
		article: {
			base: "lg:text-lg text-md",
			section: "text-center m-2"
		},
		modal: {
			container: "fixed top-1/2 left-1/2 -translate-1/2 h-9/10 w-full lg:h-4/6 lg:w-1/2 pt-2 flex items-center justify-center text-center bg-blue-200 border-2 border-blue-400 rounded-lg",
			closeContainer: "absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-100 rounded-full cursor-pointer",
			closeIcon: "w-[25px]",
		},
		button: "w-52 px-10 py-3 text-xl font-bold text-white bg-blue-500 rounded-md hover:shadow hover:bg-blue-800 cursor-pointer",
	};

	function closeCreateModal() {
		setShowCreateModal(false)
	}

	function createGame() {
		closeCreateModal();
	}

	function closeJoinModal() {
		setJoinModal(false)
	}

	function joinGame() {
		closeJoinModal();
	}

	return (
		<div className={clsx(
			"h-screen bg-blue-50", (showCreateModal || showJoinModal) && "blur-xs"
		)}>
			<header className={style.header.section}>
				<h1 className={style.header.heading}>Tug of Logic</h1>
				<h2 className={style.header.subtext}>A <a className={style.header.link} href="https://www.play-philosophy.com" target="_blank"  rel="noreferrer">Philosophy Sports</a> Game</h2>
			</header>
			<div className="lg:fixed lg:top-1/2 lg:left-1/2 lg:-translate-1/2 flex flex-col items-center justify-center m-0 gap-4 lg:gap-8">
				<article className={style.article.base}>
					<section className={style.article.section}>
						Welcome to Tug of Logic, a competitive and collaborative game for building effective arguments together upon a shifting common-ground.
					</section>
					<section className={style.article.section}>
						To play, you need a group of people assembled together (e.g. in a café or classroom) with Internet connections.
					</section>
				</article>
				<button onClick={() => setShowCreateModal(true)} className={style.button}>
					Create Game
				</button>
				<article className={style.article.base}>
					<section className={style.article.section}>
						A Logic Referee creates the game, players Join a Game.
					</section>
				</article>
				<button onClick={() => setJoinModal(true)} className={style.button}>
					Join Game
				</button>
				<article className={style.article.base}>
					<section className={style.article.section}>
						This web-app is virtual infrastructure for reasoning together.
					</section>
					<section className={style.article.section}>
						To learn how to play, visit <a href="https://www.play-philosophy.com" target="_blank"  rel="noreferrer" className="underline text-blue-500 cursor-pointer">Philosophy Sports</a>, and watch the explainer there.
					</section>
				</article>
				{showCreateModal && createPortal(
					<CreateGame modalStyle={style.modal} createGame={createGame} closeModal={closeCreateModal} />,
					root
				)}
				{showJoinModal && createPortal(
					<JoinGame modalStyle={style.modal} joinGame={joinGame} closeModal={closeJoinModal} />,
					root
				)}
			</div>
			<footer className={style.footer.section}>
				<article>
					<section className="lg:w-8/10 pl-4 lg:float-left text-sm">
  					<article className="italic font-serif">Tug of Logic is a game of participatory philosophy, created by philosopher Michael Picard.</article>
  					<section className="external-links">
  						<ul className="flex gap-6">
  							<li className={style.footer.links}><a href="https://play-philosophy.com/" target="_blank" rel="noreferrer">Play Philosophy</a></li>
  							<li className={style.footer.links}><a href="https://www.philosophical-practice.com/" target="_blank" rel="noreferrer">Philosophical Practice</a></li>
  						</ul>
  					</section>
					</section>
					<section className="lg:w-2/10 lg:float-right pt-2">
						<ol className="flex gap-2 justify-evenly">
						  <li className={style.footer.item}><a href="https://x.com/infinitarian" target="_blank" rel="noreferrer"><XIcon /></a></li>
						  <li className={style.footer.item}><a href="https://www.instagram.com/infinitarian8/" target="_blank" rel="noreferrer"><InstagramIcon /></a></li>
						  <li className={style.footer.item}><a href="https://www.linkedin.com/in/michaelpicard/" target="_blank" rel="noreferrer"><LinkedInIcon /></a></li>
						  <li className={style.footer.item}><a href="https://www.goodreads.com/author/show/22260951.Michael_Picard" target="_blank" rel="noreferrer"><GoodReadsIcon /></a></li>
						  <li className={style.footer.item}><a href="https://www.youtube.com/@michaelpicardmscphd" target="_blank" rel="noreferrer"><YouTubeIcon /></a></li>
						  <li className={style.footer.item}><a href="https://www.facebook.com/philosophysports" target="_blank" rel="noreferrer"><FacebookIcon /></a></li>
						  <li className={style.footer.item}><a href="https://philpeople.org/profiles/michael-picard" target="_blank" rel="noreferrer"><WebsiteIcon /></a></li>
						</ol>
					</section>
				</article>
			</footer>
		</div>
	);
}

export default Home;
